import type { FC } from "react";

import type { DenialPrevention } from "../types/DenialPrevention";

import ArasScorePopoverContent from "./aras-score-popover-content";
import SuggestionDetailPopoverShell, {
  arasSuggestionDetailPopoverShellSx,
} from "./suggestion-detail-popover-shell";

export interface SuggestionArasPopoverProps {
  open: boolean;
  anchorEl: HTMLElement | null;
  onClose: () => void;
  denialPrevention: DenialPrevention;
}

const SuggestionArasPopover: FC<SuggestionArasPopoverProps> = ({
  open,
  anchorEl,
  onClose,
  denialPrevention,
}) => (
  <SuggestionDetailPopoverShell
    open={open}
    anchorEl={anchorEl}
    onClose={onClose}
    sx={arasSuggestionDetailPopoverShellSx}
  >
    <ArasScorePopoverContent
      onClose={onClose}
      denialPrevention={denialPrevention}
    />
  </SuggestionDetailPopoverShell>
);

export default SuggestionArasPopover;
